import { Breadcrumb, CreateButton, ListProps } from '@refinedev/antd';
import { Card, Flex, List, Space, Typography } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import { ReactNode } from 'react';

interface ListLayoutProps extends ListProps {
  children: ReactNode;
  headerActions?: ReactNode;
  canCreate?: boolean;
}

export const ListLayout = ({
  children,
  headerActions,
  canCreate = true,
  ...props
}: ListLayoutProps) => {
  return (
    <List
      header={
        <Flex vertical gap={12}>
          <Breadcrumb />
          <Card>
            <Flex
              justify="space-between"
              align="flex-start"
              wrap="wrap"
              gap={12}
              className="sm:items-center"
            >
              <Typography.Title level={3} className="!mb-0 text-xl sm:text-2xl">
                {props.title}
              </Typography.Title>

              <Space>
                {canCreate && (
                  <>
                    {headerActions || (
                      <CreateButton
                        icon={<PlusOutlined />}
                        {...props.createButtonProps}
                      />
                    )}
                  </>
                )}

                {props.headerProps?.extra}
              </Space>
            </Flex>
          </Card>
        </Flex>
      }
      {...props}
    >
      {children}
    </List>
  );
};
